export default __webpack_public_path__ + "static/media/mic.c6ff8cf4.svg";